import type { OperatorPriceChangeSourceType } from '@/backend/market'
import type { OperatorPriceChangeTargetType } from '@/backend/market'

export class OperatorPriceChangeLogEntity {
  id?: number
  targetType?: OperatorPriceChangeTargetType
  targetId?: string | null
  itemId?: number
  branchId?: number
  changedByUserId?: string
  changedByUserDisplayName?: string | null
  oldPrice?: number
  newPrice?: number
  reason?: string | null
  sourceType?: OperatorPriceChangeSourceType
  createdAt?: string
}
